import React from "react";
import {Box} from "@material-ui/core";
import {useStyles} from "./style";

type AvatarProps = {
  img: string;
  name: string;
};
const getInitials = (name: string): string => {
  const cleanedName = name?.replace(/\([^)]*\)\s?/, "") || "";
  const words = cleanedName.split(" ");

  let initials = "";
  if (words.length > 0 && words[0].length > 0) {
    initials += words[0][0];
  }
  if (words.length > 1 && words[1].length > 0) {
    initials += words[1][0];
  }

  return initials.toUpperCase();
};

const Avatar = ({img, name}: AvatarProps) => {
  const classes = useStyles();
  return (
    <Box
      className={classes.avatar}
      style={{background: img ? "transparent" : "rgb(169, 201, 255)"}}
    >
      {img ? (
        <img src={img} alt={name} className={classes.image} />
      ) : (
        getInitials(name)
      )}
    </Box>
  );
};

export default Avatar;
